import './Timeline.css';

const Timeline = () => {
    return (
        <div className="containerTimeline worldwide">
            <div className="timeline-central-axis"></div>

            <div className="timeline-block timeline-block-left">
                <div className="marker"></div>
                <div className="timeline-content">
                    <span className="timeline-date">Octombrie 2026 - Prezent</span>
                    <h5 className="timeline-role">Master (PCSAM)</h5>
                    <h6 className="timeline-role2"><i>@ Facultatea de Automatică și Calculatoare</i></h6>
                    <p className="timeline-desc">
                        După terminarea licenței mi-a fost foarte greu să mă despart de facultatea care m-a format
                        timp de 4 ani, așa că am ales să continui cu studiile tot aici. În momentul de față studiez
                        domeniul „Ingineria Sistemelor”, iar programul de master este „Prelucrări Complexe de Semnal în
                        Aplicații Multimedia”. În mod evident, în paralel urmez și Modulul Psihopedagogic Nivel II.
                    </p>
                </div>
            </div>

            <div className="timeline-block timeline-block-right">
                <div className="marker"></div>
                <div className="timeline-content">
                    <span className="timeline-date">Septembrie 2026 - Prezent</span>
                    <h5 className="timeline-role">Prof. Ing. de Informatică și TIC</h5>
                    <h6 className="timeline-role2"><i>@ Liceul Teoretic Internațional de Informatică</i></h6>
                    <p className="timeline-desc">
                        Întrucât sunt și adeptul performanței, dar și în urma unei oportunități pe care nu o puteam rata,
                        am ajuns să predau și în cadrul Liceului Teoretic Internațional de Informatică din București. Aici
                        consider că este un alt loc în care pot evolua și lucra cu copii de alte niveluri.
                    </p>
                </div>
            </div>

            <div className="timeline-block timeline-block-left">
                <div className="marker"></div>
                <div className="timeline-content">
                    <span className="timeline-date">Septembrie 2026 - Prezent</span>
                    <h5 className="timeline-role">Prof. Ing. de Informatică și TIC</h5>
                    <h6 className="timeline-role2"><i>@ Liceul Politehnica</i></h6>
                    <p className="timeline-desc">
                        Liceul Politehnica reprezintă prima școală în care m-am titularizat în urma promovării
                        Concursului Național de Titularizare, la care am obținut nota scrisă 8.65, iar media finală
                        8.98. Aici mă simt ca acasă, întrucât liceul aparține de Universitatea Politehnica din București.
                    </p>
                </div>
            </div>

            <div className="timeline-block timeline-block-right">
                <div className="marker"></div>
                <div className="timeline-content">
                    <span className="timeline-date">Ianuarie 2026 - Martie 2026</span>
                    <h5 className="timeline-role">Membru în Comisia Științifică</h5>
                    <h6 className="timeline-role2"><i>@ Olimpiada Națională de Informatică</i></h6>
                    <p className="timeline-desc">
                        În luna decembrie a anului 2025 m-am înscris, cu destul de multă emoție, să fac parte din cadrul
                        comisiei științifice la clasa a V-a în cadrul Olimpiadei Naționale de Informatică. Iată că și de
                        data aceasta visul meu s-a îndeplinit și astfel, am avut ocazia să fac parte dintr-o comisie cu
                        oameni de valoare și să concepem probleme, teste și soluții pentru olimpiadă.
                    </p>
                </div>
            </div>

            <div className="timeline-block timeline-block-left">
                <div className="marker"></div>
                <div className="timeline-content">
                    <span className="timeline-date">Decembrie 2025</span>
                    <h5 className="timeline-role">Autor Curs Bacalaureat Informatică</h5>
                    <h6 className="timeline-role2"><i>@ i-scoala</i></h6>
                    <p className="timeline-desc">
                        Din dorința de a crea ceva care să ajute și mai mulți elevi decât cei la care pot să ajung eu
                        individual, am creat un curs online de pregătire pentru examenul de Bacalaureat la Informatică.
                        Acesta cuprinde toată materia aferentă de examen, structurată în 15 mari capitole.
                    </p>
                </div>
            </div>

            <div className="timeline-block timeline-block-right">
                <div className="marker"></div>
                <div className="timeline-content">
                    <span className="timeline-date">Septembrie 2025 - Iunie 2026</span>
                    <h5 className="timeline-role">Prof. de Informatică și TIC</h5>
                    <h6 className="timeline-role2"><i>@ Liceul Teoretic Little London</i></h6>
                    <p className="timeline-desc">
                        O nouă oportunitate mi-a stârnit interesul și m-a provocat să aleg să lucrez și în sistem privat.
                        Little London International Academy este o instituție privată din Voluntari, Ilfov, ce promite
                        multe lucruri bune, iar eu am fost bucuros să mă alătur echipei în anul școlar 2025. Aici predau
                        atât Informatică, cât și Tehnologia Informației și a Comunicațiilor, la nivel liceal.
                    </p>
                </div>
            </div>

            <div className="timeline-block timeline-block-left">
                <div className="marker"></div>
                <div className="timeline-content">
                    <span className="timeline-date">Iunie 2025 - Septembrie 2025</span>
                    <h5 className="timeline-role">Trainee FullStack Engineer</h5>
                    <h6 className="timeline-role2"><i>@ Schwarz Digits</i></h6>
                    <p className="timeline-desc">
                        După multe interviuri, am reușit să prind un post la firma SCHWARZ IT România. Sunt mândru de
                        mine, întrucât au fost sute de candidați și doar 28 de interni acceptați, iar eu m-am aflat
                        printre ei. La această firmă am lucrat cu limbajul Golang. Această experiență a reprezentat
                        prima ocazie de a lucra într-o corporație.
                    </p>
                </div>
            </div>

            <div className="timeline-block timeline-block-right">
                <div className="marker"></div>
                <div className="timeline-content">
                    <span className="timeline-date">Iunie 2025 - Noiembrie 2025</span>
                    <h5 className="timeline-role">Prof. Voluntar de Informatică și TIC</h5>
                    <h6 className="timeline-role2"><i>@ Asociația "Învață Pentru Tine"</i></h6>
                    <p className="timeline-desc">
                        Pasiunea pentru predat Informatică, dar și voluntariat, m-au adus în postura de a alege să
                        devin voluntar la asociația „Învață Pentru Tine”. Iubesc să ajut oamenii, iar dacă pot face asta
                        și voluntar, de ce nu? Aici am lucrat cu copii de toate vârstele, de la gimnaziu la liceu și i-am
                        ajutat pe partea de Informatică & TIC.
                    </p>
                </div>
            </div>

            <div className="timeline-block timeline-block-left">
                <div className="marker"></div>
                <div className="timeline-content">
                    <span className="timeline-date">Aprilie 2025 - Iunie 2025</span>
                    <h5 className="timeline-role">Prof. de Informatică și TIC </h5>
                    <h6 className="timeline-role2"><i>@ Colegiul Național "Aurel Vlaicu"</i></h6>
                    <p className="timeline-desc">
                        Am predat câteva luni Informatică & TIC la clasele IX-XI la un colegiu național. Experiența de
                        la o astfel de școală este una frumoasă pe care oricând aș mai încerca-o. Este o adevărată
                        provocare să le predai Informatică unor copii de liceu, mai ales că aceștia nu au lucrat prea
                        mult în gimnaziu, însă eu am încercat să dau tot ce am mai bun pentru a-i învăța ceva util pe
                        aceștia.
                    </p>
                </div>
            </div>

            <div className="timeline-block timeline-block-right">
                <div className="marker"></div>
                <div className="timeline-content">
                    <span className="timeline-date">Ianuarie 2025 - Prezent</span>
                    <h5 className="timeline-role">Mentor de Informatică</h5>
                    <h6 className="timeline-role2"><i>@ Algolymp</i></h6>
                    <p className="timeline-desc">
                        Algolymp reprezintă un centru de pregătire pentru excelență, axat pe mai multe categorii de elevi,
                        de la cei începători, până la cei care se pregătesc de lot. Fac parte din echipa aceasta de un
                        bun timp și pot spune că reprezintă o provocare să trec de nivelul școlar și să fac performanță
                        cu ei.
                    </p>
                </div>
            </div>

            <div className="timeline-block timeline-block-left">
                <div className="marker"></div>
                <div className="timeline-content">
                    <span className="timeline-date">Octombrie 2024 - Prezent</span>
                    <h5 className="timeline-role">Co-Founder & FullStack Web Developer</h5>
                    <h6 className="timeline-role2"><i>@ Ajutor! Dau Bacu'</i></h6>
                    <p className="timeline-desc">
                        În luna octombrie a anului 2024, alături de încă un coechipier, am început să lucrăm la un proiect ce are
                        la bază organizarea simulărilor pentru bacalaureat la toate materiile. Astfel, am început să recrutăm
                        profesori și să ne organizăm mai bine pentru a putea oferi elevilor cele mai bune și calitative
                        simulări pe care noi, simplii studenți / profesori le puteam crea.
                    </p>
                </div>
            </div>

            <div className="timeline-block timeline-block-right">
                <div className="marker"></div>
                <div className="timeline-content">
                    <span className="timeline-date">Septembrie 2024 - Prezent</span>
                    <h5 className="timeline-role">Prof. Ing. de Informatică și TIC</h5>
                    <h6 className="timeline-role2"><i>@ Liceul Teoretic "George Călinescu"</i></h6>
                    <p className="timeline-desc">
                        Acest liceu este liceul meu de suflet, întrucât aici am învățat 4 ani. Predau totuși doar TIC,
                        însă asta nu mă oprește din a învăța alte lucruri noi și interesante. De când predau aici am
                        învățat multe lucruri utile pe care le poți face la această disciplină, de care nici eu nu știam.
                        Colectivul este unul minunat, mă bucur să fiu coleg cu foștii mei profesori și să îi fac mândri
                        de ceea ce am ajuns astăzi.
                    </p>
                </div>
            </div>

            <div className="timeline-block timeline-block-left">
                <div className="marker"></div>
                <div className="timeline-content">
                    <span className="timeline-date">Iulie 2024 - Septembrie 2024</span>
                    <h5 className="timeline-role">Web Developer Intern</h5>
                    <h6 className="timeline-role2"><i>@ FeedCheck</i></h6>
                    <p className="timeline-desc">
                        Pot spune că FeedCheck, locul în care am ocupat această poziție, a fost primul meu Internship
                        adevărat. Aici am avut prezență fizică la muncă, la un birou. Chiar dacă era un startup, echipa
                        a fost foarte primitoare și deschisă, iar eu pot spune că am învățat lucruri noi. Din cauza
                        facultății a trebuit să renunț la job.
                    </p>
                </div>
            </div>

            <div className="timeline-block timeline-block-right">
                <div className="marker"></div>
                <div className="timeline-content">
                    <span className="timeline-date">Mai 2024 - Octombrie 2024</span>
                    <h5 className="timeline-role">Team Lead & FrontEnd Developer</h5>
                    <h6 className="timeline-role2"><i>@ DiviGO</i></h6>
                    <p className="timeline-desc">
                        Pe lângă pasiunea mea pentru tehnologie se numără și partea de a „manageria” o echipă. La DiviGO, căci
                        așa se numea locul unde am lucrat, am avut ocazia să coordonez echipa de FrontEnd și să ajut
                        totodată și la dezvoltarea unei aplicații destul de interesante. A fost o experiență frumoasă
                        din care am mai învățat câte ceva și cu siguranță mi-ar plăcea să mai am astfel de experiențe
                        și pe viitor.
                    </p>
                </div>
            </div>

            <div className="timeline-block timeline-block-left">
                <div className="marker"></div>
                <div className="timeline-content">
                    <span className="timeline-date">Octombrie 2023 - Prezent</span>
                    <h5 className="timeline-role">Asistent Universitar Voluntar</h5>
                    <h6 className="timeline-role2"><i>@ Facultatea de Automatică și Calculatoare</i></h6>
                    <p className="timeline-desc">
                        În calitate de asistent universitar în regim voluntar, am avut ocazia încă din anul 2 să ajut
                        profesorii în coordonarea laboratoarelor. Am reușit să fac parte din echipa de voluntari la
                        discipline precum „Programarea Calculatoarelor și Limbaje de Programare”, „Structuri de Date și
                        Algoritmi”, „Programare Orientată pe Obiecte”, dar și „Tehnologii Web”, iar în momentul de față
                        continui să fac aceste lucruri.
                    </p>
                </div>
            </div>

            <div className="timeline-block timeline-block-right">
                <div className="marker"></div>
                <div className="timeline-content">
                    <span className="timeline-date">Octombrie 2022 - Iunie 2026</span>
                    <h5 className="timeline-role">Licență (IS) - Titlu de Inginer</h5>
                    <h6 className="timeline-role2"><i>@ Facultatea de Automatică și Calculatoare</i></h6>
                    <p className="timeline-desc">
                        Pasiunea pentru Informatică și Tehnologie m-a adus la una dintre cele mai prestigioase facultăți
                        de domeniu din România, anume la Facultatea de „Automatică și Calculatoare” din cadrul
                        „Universității Naționale de Științe și Tehnologie Politehnica București”. Aici am studiat 
                        domeniul „Ingineria Sistemelor” și programul de studii „Automatică și Informatică Aplicată”, iar în
                        paralel și Modulul Psihopedagogic Nivel I pe care l-am absolvit cu media 10.
                    </p>
                </div>
            </div>

            <div className="timeline-block timeline-block-left">
                <div className="marker"></div>
                <div className="timeline-content">
                    <span className="timeline-date">Decembrie 2021</span>
                    <h5 className="timeline-role">Autor Agendă Informatică Bacalaureat</h5>
                    <h6 className="timeline-role2"><i>@ Edeea (Fost Gradesy)</i></h6>
                    <p className="timeline-desc">
                        Experiența și pasiunea mea pentru Informatică a fost înglobată cu succes într-o agendă tip culegere pentru
                        Informatică. Această agendă a fost special creată pentru pregătirea pentru examenul de Bacalaureat și
                        conține toată materia aferentă acestuia. Am muncit o vară întreagă pentru acest produs, iar în zilele de
                        astăzi îi aducem îmbunătățiri pentru a fi la curent cu cerințele actuale. Această agendă poate fi găsită
                        pe site-ul celor de la Edeea.
                    </p>
                </div>
            </div>

            <div className="timeline-block timeline-block-right">
                <div className="marker"></div>
                <div className="timeline-content">
                    <span className="timeline-date">Iunie 2020 - Prezent</span>
                    <h5 className="timeline-role">Prof. Meditator</h5>
                    <h6 className="timeline-role2"><i>@ Individual / Grupe</i></h6>
                    <p className="timeline-desc">
                        Prima interacțiune pe care am avut-o cu predatul informaticii propriu-zise am avut-o la final de clasa a X-a.
                        La scurt timp după asta, am zis să încerc să împărtășesc cunoștințele mele și cu alte persoane, în regim
                        de pregătiri individuale. Mi-a plăcut foarte mult să fac asta și iată că până în prezent mă ocup cu aceste
                        ședințe individuale de pregătire și inspir în continuare elevii să reușească să obțină note mari în
                        examene.
                    </p>
                </div>
            </div>

            <div className="timeline-block timeline-block-left">
                <div className="marker"></div>
                <div className="timeline-content">
                    <span className="timeline-date">Septembrie 2018 - Iunie 2022</span>
                    <h5 className="timeline-role">Elev - Șef de promoție</h5>
                    <h6 className="timeline-role2"><i>@ Liceul Teoretic George Călinescu</i></h6>
                    <p className="timeline-desc">
                        Anii de liceu i-am petrecut în cadrul Liceului Teoretic George Călinescu din București, la
                        specializarea matematică-informatică. Au fost niște ani frumoși de adolescență care m-au format
                        și m-au determinat să ajung omul care sunt astăzi. Pe parcursul anilor de liceu am fost și șef
                        de clasă, iar în final am terminat cei 4 ani în calitate de șef de promoție.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Timeline;